import React from 'react';

import QuotesSVG from '../../../../../assets/svg-components/growth/quotes.svg';
import { Text } from '../../../../../components/text/text';
import { cn } from '../../../../../utils/classname';
import './quote.scss';

type GrowthCardProps = {
  children: any;
  color: 'light-purple' | 'dark-purple' | 'orange' | 'blue';
};

export const Quote: React.FC<GrowthCardProps> = ({ children, color }) => (
  <div className="rc-growth-quote">
    <div className={cn('rc-growth-quote__image', `rc-growth-quote__image--color-${color}`)}>
      <QuotesSVG />
    </div>
    <Text>{children}</Text>
  </div>
);
